/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiResponseDTOListBankUssdRecord } from '../models/ApiResponseDTOListBankUssdRecord';
import type { ApiResponseDTOListProviderRecord } from '../models/ApiResponseDTOListProviderRecord';
import type { ApiResponseDTOOperationDTO } from '../models/ApiResponseDTOOperationDTO';
import type { ApiResponseDTOOperationFullDTO } from '../models/ApiResponseDTOOperationFullDTO';
import type { ConfirmPaymentLinkRecord } from '../models/ConfirmPaymentLinkRecord';
import type { ConfirmPaymentLinkUssdRecord } from '../models/ConfirmPaymentLinkUssdRecord';
import type { ServerSentEventApiResponseDTOOperationFullDTO } from '../models/ServerSentEventApiResponseDTOOperationFullDTO';
import type { ShareReceiptEmailReqDTO } from '../models/ShareReceiptEmailReqDTO';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class PaymentLinkPublicApiService {

    /**
     * Get Payment Link Operation by operationId
     * Retrieves the Payment Link Operation based on operationId.
     * @param operationId 
     * @returns ApiResponseDTOOperationFullDTO OK
     * @throws ApiError
     */
    public static getPaymentLinkOperationById(
operationId: string,
): CancelablePromise<ApiResponseDTOOperationFullDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/operation/payment-link/{operationId}',
            path: {
                'operationId': operationId,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                501: `Not Implemented`,
                503: `Service Unavailable`,
            },
        });
    }

    /**
     * Post Payment Link for IN_BANK_TRANSFER Operation
     * Post Payment Link for IN_BANK_TRANSFER Operation.
     * @param operationId 
     * @param requestBody 
     * @returns ApiResponseDTOOperationDTO Created
     * @throws ApiError
     */
    public static postPaymentLinkInBankTransfer(
operationId: string,
requestBody: ConfirmPaymentLinkRecord,
): CancelablePromise<ApiResponseDTOOperationDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/operation/payment-link/{operationId}/bank-transfer',
            path: {
                'operationId': operationId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                501: `Not Implemented`,
                503: `Service Unavailable`,
            },
        });
    }

    /**
     * Post Payment Link for Card operation
     * Post Payment Link for Card operation
     * @param operationId 
     * @param requestBody 
     * @returns ApiResponseDTOOperationDTO OK
     * @throws ApiError
     */
    public static postPaymentLinkCard(
operationId: string,
requestBody: ConfirmPaymentLinkRecord,
): CancelablePromise<ApiResponseDTOOperationDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/operation/payment-link/{operationId}/card',
            path: {
                'operationId': operationId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                501: `Not Implemented`,
                503: `Service Unavailable`,
            },
        });
    }

    /**
     * Get providers
     * Retrieves a list of providers.
     * @param operationId 
     * @returns ApiResponseDTOListProviderRecord OK
     * @throws ApiError
     */
    public static getProvidersForPaymentLink(
operationId: string,
): CancelablePromise<ApiResponseDTOListProviderRecord> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/operation/payment-link/{operationId}/momo/provider',
            path: {
                'operationId': operationId,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                501: `Not Implemented`,
                503: `Service Unavailable`,
            },
        });
    }

    /**
     * @param operationId 
     * @returns ApiResponseDTOOperationFullDTO OK
     * @throws ApiError
     */
    public static getOperationLongPolling1(
operationId: string,
): CancelablePromise<ApiResponseDTOOperationFullDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/operation/payment-link/{operationId}/poll',
            path: {
                'operationId': operationId,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                501: `Not Implemented`,
                503: `Service Unavailable`,
            },
        });
    }

    /**
     * Post Payment Link for QR_CODE Operation
     * Post Payment Link for QR_CODE Operation.
     * @param operationId 
     * @param requestBody 
     * @returns ApiResponseDTOOperationDTO Created
     * @throws ApiError
     */
    public static postPaymentLinkQrCode(
operationId: string,
requestBody: ConfirmPaymentLinkRecord,
): CancelablePromise<ApiResponseDTOOperationDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/operation/payment-link/{operationId}/qr-code',
            path: {
                'operationId': operationId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                501: `Not Implemented`,
                503: `Service Unavailable`,
            },
        });
    }

    /**
     * Export Payment Link Receipt
     * Export Payment Link Receipt as PDF
     * @param operationId 
     * @returns any OK
     * @throws ApiError
     */
    public static exportPaymentLinkReceipt(
operationId: string,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/operation/payment-link/{operationId}/receipt',
            path: {
                'operationId': operationId,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                501: `Not Implemented`,
                503: `Service Unavailable`,
            },
        });
    }

    /**
     * Share Payment Link Receipt
     * Share Payment Link Receipt as PDF by Email
     * @param operationId 
     * @param requestBody 
     * @returns any OK
     * @throws ApiError
     */
    public static sharePaymentLinkReceipt(
operationId: string,
requestBody: ShareReceiptEmailReqDTO,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/operation/payment-link/{operationId}/receipt/share',
            path: {
                'operationId': operationId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                501: `Not Implemented`,
                503: `Service Unavailable`,
            },
        });
    }

    /**
     * @param operationId 
     * @returns ServerSentEventApiResponseDTOOperationFullDTO OK
     * @throws ApiError
     */
    public static getOperationSse(
operationId: string,
): CancelablePromise<Array<ServerSentEventApiResponseDTOOperationFullDTO>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/operation/payment-link/{operationId}/sse',
            path: {
                'operationId': operationId,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                501: `Not Implemented`,
                503: `Service Unavailable`,
            },
        });
    }

    /**
     * Post Payment Link for USSD Operation
     * Post Payment Link for USSD Operation.
     * @param operationId 
     * @param requestBody 
     * @returns ApiResponseDTOOperationDTO Created
     * @throws ApiError
     */
    public static postPaymentLinkUssd(
operationId: string,
requestBody: ConfirmPaymentLinkUssdRecord,
): CancelablePromise<ApiResponseDTOOperationDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/operation/payment-link/{operationId}/ussd',
            path: {
                'operationId': operationId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                501: `Not Implemented`,
                503: `Service Unavailable`,
            },
        });
    }

    /**
     * Get available USSD Banks
     * Retrieves a list of available USSD Banks.
     * @param operationId 
     * @returns ApiResponseDTOListBankUssdRecord OK
     * @throws ApiError
     */
    public static getAvailableUssdBanks(
operationId: string,
): CancelablePromise<ApiResponseDTOListBankUssdRecord> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/operation/payment-link/{operationId}/ussd/banks',
            path: {
                'operationId': operationId,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                501: `Not Implemented`,
                503: `Service Unavailable`,
            },
        });
    }

}
